webpackJsonp([3483998086454845400],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/local-or-global-choosing-a-secondary-index-type-in-dynamo-db.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"allPostTitles": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"tocTitle": "Choosing an index type",
								"title": "Local or global: Choosing a secondary index type in DynamoDB",
								"lesson": 1,
								"chapter": 7,
								"type": "lesson"
							},
							"fields": {
								"slug": "/local-or-global-choosing-a-secondary-index-type-in-dynamo-db"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "DynamoDB Streams",
								"lesson": 4,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/dynamodb-streams"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Global Secondary Indexes",
								"lesson": 3,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/global-secondary-indexes"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Local Secondary Indexes",
								"lesson": 2,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/local-secondary-indexes"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Secondary Indexes",
								"lesson": 1,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/secondary-indexes"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "MongoDB vs. DynamoDB",
								"lesson": 1,
								"chapter": 8,
								"type": "lesson"
							},
							"fields": {
								"slug": "/mongo-db-vs-dynamo-db"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Working with Multiple Items",
								"lesson": 1,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/working-with-multiple-items"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Filtering",
								"lesson": 4,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/filtering"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Scans",
								"lesson": 3,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/scans"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Querying",
								"lesson": 2,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/querying"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Hierarchical Data",
								"lesson": 2,
								"chapter": 6,
								"type": "lesson"
							},
							"fields": {
								"slug": "/hierarchical-data"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Leaderboard & Write Sharding",
								"lesson": 3,
								"chapter": 6,
								"type": "lesson"
							},
							"fields": {
								"slug": "/leaderboard-write-sharding"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Overview",
								"lesson": 1,
								"chapter": 6,
								"type": "lesson"
							},
							"fields": {
								"slug": "/data-modeling-overview"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Backups & Restores",
								"lesson": 3,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/backups-restores"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Autoscaling",
								"lesson": 4,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/autoscaling"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Provisioning tables",
								"lesson": 1,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/provisioning-tables"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Global Tables",
								"lesson": 5,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/global-tables"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Security",
								"lesson": 2,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/security"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Additional Reading",
								"lesson": 1,
								"chapter": 9,
								"type": "lesson"
							},
							"fields": {
								"slug": "/additional-reading"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Anatomy of an Item",
								"lesson": 1,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/anatomy-of-an-item"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Inserting & Retrieving Items",
								"lesson": 2,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/inserting-retrieving-items"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Updating & Deleting Items",
								"lesson": 4,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/updating-deleting-items"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Environment Setup",
								"lesson": 4,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/environment-setup"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Expression Basics",
								"lesson": 3,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/expression-basics"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "The Dynamo Paper",
								"lesson": 3,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/the-dynamo-paper"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Key Concepts",
								"lesson": 2,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/key-concepts"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "What is DynamoDB?",
								"lesson": 1,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/what-is-dynamo-db"
							}
						}
					}
				]
			},
			"postBySlug": {
				"html": "<p>Secondary indexes are a critical part of modeling your data in DynamoDB. With a secondary index, you can add additional access patterns to your application without the hassle of maintaining multiple copies of the same data. DynamoDB will handle all replication from the base table to your secondary index.</p>\n<p>There are two types of secondary indexes: local secondary indexes and global secondary indexes. They are pretty similar overall, but there are some slight differences in how they function.</p>\n<p>In this lesson, we'll see how to choose between a local and global secondary index. We'll cover:</p>\n<ul>\n<li>The benefits of a local secondary index;</li>\n<li>The limitations of a local secondary index.</li>\n<li>The TL;DR flow chart version of choosing an index type</li>\n</ul>\n<h2 id=\"the-benefits-of-a-local-secondary-index\"><a href=\"#the-benefits-of-a-local-secondary-index\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>The benefits of a local secondary index</h2>\n<p>I default to using global secondary index for all of my indexes and rarely consider using local secondary indexes. That said, there are two features of local secondary indexes that you can't get with global secondary indexes. These features are:</p>\n<ul>\n<li>Strongly-consistent reads</li>\n<li>Reuse of base table capacity</li>\n</ul>\n<p>Let's review each of these.</p>\n<h3 id=\"strongly-consistent-reads\"><a href=\"#strongly-consistent-reads\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Strongly-consistent reads</h3>\n<p>When reading from your base table in DynamoDB, you can <a href=\"https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/HowItWorks.ReadConsistency.html\">choose between strongly consistent reads and eventually consistent reads</a>. A strongly consistent read will return the latest value for a given item, incorporating all successful write operations that have occurred. An eventually consistent read will likely include the latest value for a given item but may reflect slightly stale data. This is due to how DynamoDB (and NoSQL databases generally) replicate data across replicas.</p>\n<p>By default, all reads will be eventually consistent. An eventually consistent read consumes half the read capacity units of a strongly consistent read. If you want a strongly consistent read, you'll need to include the <code>ConsistentRead</code> property in your API request.</p>\n<p>With a local secondary index, you have the same options as with a base table. By default, all reads from a local secondary index are eventually consistent. However, you may opt into a strongly consistent read if you need it. With a global secondary index, you don't have this option. All reads from a global secondary index are eventually consistent.</p>\n<p>If you have strong consistency requirements in your application, the local secondary index is a better choice for you.</p>\n<h3 id=\"reuse-of-base-table-capacity\"><a href=\"#reuse-of-base-table-capacity\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Reuse of base table capacity</h3>\n<p>A second benefit of local secondary indexes is that they reuse the provisioned throughput from your base table. In certain situations, this can be cheaper than global secondary indexes.</p>\n<p>If you're using the <a href=\"https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/HowItWorks.ReadWriteCapacityMode.html#HowItWorks.ProvisionedThroughput.Manual\">Provisioned pricing mode</a> for DynamoDB, you'll provision a certain number of read and write capacity units for your DynamoDB table. This specifies the maximum number of read and write operations per second that your table can handle.</p>\n<p>If you're using a global secondary index, you will need to specify additional read and write capacity units for that index separately from your main table. However, with a local secondary index, you will use the capacity from your base table.</p>\n<p>In most situations, this won't save you much money. You'll need to figure the capacity needed for your main table and the capacity needed for your local secondary index. Add them together, and this is the number you'll need for your base table's provisioned throughput.</p>\n<p>However, these shared capacity units could be helpful if you have an uneven workload across time such that sharing units could reduce the overall capacity units you need. This could come up in two scenarios.</p>\n<p>First, if your read patterns on your base table and secondary index are temporally different. Perhaps your base table is read a lot in the morning and afternoon, while your local secondary index is read a lot overnight when runnning reports. In this case, you wouldn't need to provision capacity units on two separate entities that both account for their respective high water marks. Rather, you could share across them.</p>\n<p>The second example is if you had multiple sparse local secondary indexes on your table. Generally, a write to your table with a local secondary index will cost 2X what it would cost for just the base table, as any write will be replicated to the index as well. However, if you had three sparse indexes on your table, and any write to your base table was only replicated to a single local secondary index, you could get efficiencies by sharing the capacity units across the multiple indexes.</p>\n<p>In reality, both of these situations aren't that common. It's unlikely you'll be able to save a meaningful amount of money by choosing a local secondary index over a global secondary index.</p>\n<h2 id=\"downsides-of-local-secondary-indexes\"><a href=\"#downsides-of-local-secondary-indexes\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Downsides of local secondary indexes</h2>\n<p>Now that we've seen the potential upsides of a local secondary index, let's take a look at the downsides. There are three main downsides to local secondary indexes:</p>\n<ul>\n<li>Must use the same partition key as the base table</li>\n<li>Must be created when the table is created</li>\n<li>Adds a 10GB limit to any single item collection</li>\n</ul>\n<p>Let's review each of these in turn.</p>\n<h3 id=\"must-use-the-same-partition-key-as-the-base-table\"><a href=\"#must-use-the-same-partition-key-as-the-base-table\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Must use the same partition key as the base table</h3>\n<p>The most common reason that a local secondary index won't work for your application is because a local secondary index must use the same partition key as your base table. For many application patterns, this is not feasible.</p>\n<p>That said, this can be a useful pattern for some folks. If you have a dataset where you're usually searching within a particular partition but have different sorting patterns within the partion, it can be a nice fit.</p>\n<p>One example is a table containing actors and actresses and the various movies in which they've appeared. You might have an access pattern where you want to fetch all movies for a particular actor in a way where you can filter based on the name of the movie. Your base table would look as follows:</p>\n<img src=\"https://user-images.githubusercontent.com/6509926/72524174-f2b3be00-3826-11ea-9db5-a13d03c1a07b.png\" alt=\"Base table with Actors and Movies\">\n<p>In this table, the actor's name is the partition key and the movie name is the sort key.</p>\n<p>Then, you might have a second access pattern that wants to find all movies for an actor within a given time range. You could set up a local secondary index where the partition key is Actor and the sort key is Year.</p>\n<img src=\"https://user-images.githubusercontent.com/6509926/72524173-f2b3be00-3826-11ea-8f4a-1300e2b15777.png\" alt=\"LSI with Actor and Year\">\n<p>Note that this is the same data, it has just been rearranged due to a secondary indexes. In this example, the partition key is the same for our base table and index -- the actor's name.</p>\n<p>If you had a third access pattern where you wanted to find all the actors in a particular movie, a local secondary index wouldn't work. In this secondary index, you'd need to make Movie your partition key and Actor your sort key.</p>\n<img src=\"https://user-images.githubusercontent.com/6509926/72524172-f2b3be00-3826-11ea-83f5-eefbc4f1cc45.png\" alt=\"GSI with Movies and Actors\">\n<p>Because the partition key is different than your base table, you couldn't use a local secondary index.</p>\n<h3 id=\"local-secondary-indexes-must-be-created-when-the-table-is-created\"><a href=\"#local-secondary-indexes-must-be-created-when-the-table-is-created\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Local secondary indexes must be created when the table is created</h3>\n<p>A second reason that local secondary indexes aren't used is because of the timing -- they must be created when the table is created. If your table already exists and you want to add an additional secondary index to enable more access patterns, you must use a global secondary index.</p>\n<p>In general, this shouldn't be a huge deal. When using DynamoDB, you should plan for all of your access patterns up front, before you design and create your table. It is at this point that you can plan for a local secondary index.</p>\n<p>That said, applications evolve and access patterns change. You may find yourself adding secondary indexes after your table has been live for a while. In those cases, a global secondary index is your only option.</p>\n<h3 id=\"local-secondary-indexes-add-an-item-collection-size-limit\"><a href=\"#local-secondary-indexes-add-an-item-collection-size-limit\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Local secondary indexes add an item collection size limit</h3>\n<p>The final downside to local secondary indexes is more obscure but can really bite you in the wrong situation. If you add a local secondary index, there is a 10GB limit to any given item collection.</p>\n<p>What is an item collection? I'm glad you asked! An item collection is all of the items with the same partition key in your base table and local secondary indexes. For example, in our Movies example from earlier, we would have three item collections: Tom Hanks, Tim Allen, and Natalie Portman.</p>\n<img src=\"https://user-images.githubusercontent.com/6509926/72524797-4d014e80-3828-11ea-92ea-0195e8a01c0c.png\" alt=\"Item collections with Actors &#x26; Movies\">\n<p>In a single actor's partition, you would need to add up the total size of the items to get the size of the item collection. When you're using a local secondary index, the item collection includes the size of all items with that partition key in the local secondary index as well. If you're projecting the full item into your index, this would double the size of your item collection.</p>\n<p>This won't be a problem for most applications if you have a partition key with high cardinality to distribute values across your key space. But what if you had an actor that's been in a lot of movies?</p>\n<img src=\"https://user-images.githubusercontent.com/6509926/72524798-4d014e80-3828-11ea-8881-140eedf11ee0.png\" alt=\"Actors &#x26; Movies with Samuel L. Jackson\">\n<p>Samuel L. Jackson has been in <em>a lot</em> of movies. Now you might hit the item collection limit. This would block reads on your base table if you would exceed the 10GB limit, which would be a frightening surprise.</p>\n<p>Note that the 10GB item collection size limit does not apply at all if you don't have a local secondary index on your table. If you're using local secondary indexes and are worried about hitting the size limit, the DynamoDB docs have good advice on <a href=\"https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/LSI.html#LSI.ItemCollections.SizeLimit\">monitoring the size of your item collections</a> to alert you before it's too late.</p>\n<h2 id=\"the-too-long-didnt-read-version-of-choosing-an-index\"><a href=\"#the-too-long-didnt-read-version-of-choosing-an-index\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>The 'Too long; Didn't Read' version of choosing an index</h2>\n<p>In the sections above, we walked through the pros and cons of local secondary indexes. A global secondary index is a more vanilla version of the local secondary index. It doesn't have the upsides like strong consistency or shared capacity, but it also doesn't have the downsides of item collection size limits or the same partition key requirement.</p>\n<p>For those of you that want a quick answer to choosing an index, this section has the quick version. The basic flow is as follows:</p>\n<p><img src=\"https://user-images.githubusercontent.com/6509926/72526710-a66b7c80-382c-11ea-8923-dbb9c9589881.png\" alt=\"Secondary Index flow chart\"></p>\n<p>Starting at the top left, work your way down the left side to see if there's any reason you <em>should</em> consider a local secondary index. If neither of the two main reasons help you, then choose a global secondary index.</p>\n<p>If you think you do have a reason for using a local secondary index, then move to the right side to see if there will be any reasons you <em>can't</em> use a local secondary index.</p>\n<ul>\n<li>Does my secondary index have a different partition key from my base table?</li>\n<li>Does my table already exist?</li>\n<li>Will one of my item collections exceed 10GB?</li>\n</ul>\n<p>If the answer to all of these questions is \"No\", then I could use a local secondary index. If any of them are \"Yes\", then I need to rethink my needs, recreate my table, or just use a global secondary index.</p>",
				"timeToRead": 8,
				"excerpt": "Secondary indexes are a critical part of modeling your data in DynamoDB. With a secondary index, you can add additional access patterns to...",
				"frontmatter": {
					"title": "Local or global: Choosing a secondary index type in DynamoDB",
					"date": "1/16/2020",
					"category": null,
					"description": "Compare local secondary indexes and global secondary indexes in DynamoDB, and learn when you should choose one over the other."
				},
				"fields": {
					"slug": "/local-or-global-choosing-a-secondary-index-type-in-dynamo-db"
				}
			}
		},
		"pathContext": {
			"slug": "/local-or-global-choosing-a-secondary-index-type-in-dynamo-db"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---local-or-global-choosing-a-secondary-index-type-in-dynamo-db-b9d40ca72b28d9c9620c.js